<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText=""
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="streams"
            :custom-filter="customFilter"
            :single-expand="true"
            item-key="name"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.program_id`]="{ value }">
              {{ getProgram(value) }}
            </template>
            <template #[`item.name`]="{ item }">
              <span
                @click="showStreamSchemes(item)"
                style="
                  cursor: pointer;
                  color: #4f4584;
                  text-decoration: underline;
                "
                >{{ item.name }}</span
              >
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                @click="openConfirm(item)"
                small
                :color="item.active ? 'green' : 'red'"
                dark
              >
                {{ showActiveStatus(item.active) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createStream"
        @update="updateStream"
        :stream="stream"
        :programs="programs"
        :edit="editMode"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="program"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/stream/form.vue";
import searchBar from "@/components/searchBar.vue";
import { streamHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";
export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  data() {
    return {
      search: "",
      headers: streamHeaders,
      dialog: false,
      editMode: false,
      streams: [],
      programs: [],
      stream: {},
      showDialog: false,
      currentItem: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Streams" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getStreams();
      this.getPrograms();
    },
    async getStreams() {
      await this.$axios
        .get("streams")
        .then((res) => {
          this.streams = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios
        .get("programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async createStream(data) {
      await this.$axios
        .post("streams", { stream: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateStream(data) {
      await this.$axios
        .put("streams/" + data.id, { stream: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Stream updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    changeConfirmation() {
      this.updateStream({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },

    edit(item) {
      this.stream = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.stream = {};
      this.showDialog = false;
      this.currentItem = {};
    },
    getProgram(id) {
      const program = this.programs.find((p) => p.id === id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const activeStatus = this.showActiveStatus(item.active);
      const program = this.getProgram(item.program_id);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        activeStatus.toLowerCase().includes(search.toLowerCase()) ||
        program.toLowerCase().includes(search.toLowerCase())
      );
    },
    showStreamSchemes(item) {
      this.$router.push({
        name: "Stream Scheme Lists",
        query: { id: item.id, name: item.name, program_id: item.program_id },
      });
    },
  },
};
</script>

<style>
.reset-card-text {
  font-size: medium !important;
  font-weight: normal !important;
  line-height: normal !important;
  letter-spacing: normal !important;
}
</style>
